var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowTrendUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 128V288C576 305.672 561.688 320 544 320S512 305.672 512 288V205.25L342.625 374.625C336.375 380.875 328.188 384 320 384S303.625 380.875 297.375 374.625L192 269.25L54.625 406.625C48.375 412.875 40.188 416 32 416C13.721 416 0 401.053 0 384C0 375.812 3.125 367.625 9.375 361.375L169.375 201.375C175.625 195.125 183.812 192 192 192S208.375 195.125 214.625 201.375L320 306.75L466.75 160H384C366.312 160 352 145.672 352 128S366.312 96 384 96H544C560.775 96 576 109.372 576 128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrendUp);
export default __webpack_public_path__ + "static/media/arrow-trend-up.5a83e0f99b6632c41224ded25acdb337.svg";
export { ForwardRef as ReactComponent };